import Form from './newForm'

$(() => { $('.js__newForm').each((index, el) => new Form($(el))) })
